<div class="stepper-container" data-cy="stepper" data-variant="variant2">
  <div
    class="stepper-keys"
    [style.color]="config().body.progressbar.labelColor"
  >
    @let earnLabel = config().body.progressbar.earnLabel;
    @if (earnLabel) {
      <p class="earn" [style.color]="config().body.progressbar.earnLabelColor">
        {{ earnLabel }}
      </p>
    }
    <p class="spend" [style.top]="config().body.progressbar.spendLabelTop">
      {{ config().body.progressbar.spendLabel }}
    </p>
  </div>
  <div class="progress-bar-container">
    <div
      class="progress-bar"
      [style.backgroundColor]="config().body.progressbar.containerColor"
    ></div>
    <div
      data-cy="progress-bar"
      class="progress-bar-value"
      [style]="{
        width: challenge() | progressWidth: limitsPerNbSteps,
        backgroundColor: config().body.progressbar.progressColor,
      }"
    ></div>
  </div>
  <div
    class="steps"
    [style.left]="
      challenge().targets.length === 1
        ? '0'
        : challenge().targets.length === 2
          ? '0'
          : '0'
    "
  >
    @for (item of challenge().targets; track i; let i = $index) {
      @let stepStatus = challenge() | stepStatus: i;

      <div
        class="stepper-item"
        [class]="stepStatus"
        [style.marginRight]="
          challenge().targets.length === 2 && i === 0 ? '40px' : 0
        "
      >
        <div
          data-cy="active_step_img"
          class="reward-container {{ stepStatus }}"
        >
          @let stepCompleted = config().body.rewards.stepCompleted;
          @if (stepCompleted && stepStatus === StepStatus.DEFAULT) {
            <img
              class="step-completed"
              [src]="stepCompleted.imageUrl"
              [alt]="stepCompleted.alternativeText"
            />
          }
          <div
            b2cSvg
            width="65px"
            class="bubble"
            [style.minHeight]="config().body.rewards.bubbleHeight"
            [svgPath]="config().body.rewards.defaultPath"
            [alt]="
              config().body.rewards.alternativeText[stepStatus]
                | replaceVars: challenge().steps[i].reward
            "
            [fill]="config().body.rewards.backgroundColors[stepStatus].fill"
            [stroke]="config().body.rewards.backgroundColors[stepStatus].stroke"
          ></div>

          <div
            class="label-reward"
            [style]="{
              color: config().body.rewards.color,
              fontFamily: config().body.rewards.fontFamily,
            }"
          >
            @if (config().body.passedWording || config().body.activeWording) {
              <p class="step-wording">
                <!-- Reached|Passed Status -->
                @if (
                  [StepStatus.REACHED, StepStatus.DEFAULT].includes(stepStatus)
                ) {
                  {{ config().body.passedWording }}
                } @else {
                  {{ config().body.activeWording }}
                }
              </p>
            }

            <div class="step-reward-container">
              <div
                class="step-reward"
                [innerHTML]="challenge().steps[i].reward | formatReward | safe"
              ></div>

              @let rewardIcons = config().body.rewards.icons;
              @if (rewardIcons) {
                @let rewardIcon = rewardIcons[stepStatus];
                <img
                  class="reward-icon"
                  [src]="rewardIcon.imageUrl"
                  [alt]="rewardIcon.alternativeText"
                />
              }
            </div>
          </div>
        </div>

        <div class="step-target-container">
          @if (![StepStatus.REACHED, StepStatus.DEFAULT].includes(stepStatus)) {
            <div
              data-cy="target_coming"
              [class]="'unreached ' + stepStatus"
              [style]="{
                color: config().body.targets.color,
                border: config().body.targets.border,
                'min-height': config().body.targets.height,
                fontFamily: config().body.targets.fontFamily,
                borderRadius: config().body.targets.borderRadius,
                backgroundColor: config().body.targets.backgroundColor,
              }"
              [title]="
                config().body.targets.targetUnReachedTitle
                  | replaceVars: challenge().steps[i].target
              "
            >
              {{ challenge().steps[i].target | formatAmount: 'currency' : 0 }}
            </div>
          }

          <!-- Active Status -->
          @if ([StepStatus.REACHED].includes(stepStatus)) {
            <div class="reached" data-cy="target_reached">
              <img
                [src]="config().body.targets.onIcon.imageUrl"
                [alt]="
                  config().body.targets.onIcon.onIconAlternativeText
                    | replaceVars: challenge().steps[i].target
                "
              />
            </div>
          }

          <!-- Passed Status -->
          @if ([StepStatus.DEFAULT].includes(stepStatus)) {
            <div class="reached" data-cy="target_reached">
              <img
                [src]="config().body.targets.offIcon.imageUrl"
                [alt]="
                  config().body.targets.offIcon.offIconAlternativeText
                    | replaceVars: challenge().steps[i].target
                "
              />
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
